module.exports = __webpack_public_path__ + "static/media/metrics_no_change.7f225727.svg";